export default __webpack_public_path__ + "static/media/leg-right-inside.43c64d5e.png";